import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CarouselItem } from '../carousel.service';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
  selector: 'ag-carousel-item',
  templateUrl: './carousel-item.component.html',
  styleUrls: ['./carousel-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CarouselItemComponent {
  @Input() carouselItem: CarouselItem;
  @Input()
  get showCallNumber(): boolean {
    return this._showCallNumber;
  }
  set showCallNumber(value: string) {
    this._showCallNumber = coerceBooleanProperty(value);
  }
  private _showCallNumber: boolean;

  @Output() selectedCarouselItem = new EventEmitter<CarouselItem>();

  constructor(private _elementRef: ElementRef) {
    this._elementRef.nativeElement.classList.add('swiper-slide');
  }

  goToFullRecord(carouselItem: CarouselItem) {
    this.selectedCarouselItem.emit(carouselItem);
  }
}
